import TablesIntro from './TablesIntro'

export default TablesIntro